// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3MqvO","title":"ClientReferral_title__22mdE","itemText":"ClientReferral_itemText__3Wk3c"};